import { cn } from '../../lib/utils';
import './ui.css';

const variantClass = {
  default: 'ui-button-default',
  secondary: 'ui-button-secondary',
  outline: 'ui-button-outline',
  ghost: 'ui-button-ghost',
  destructive: 'ui-button-destructive',
};

const sizeClass = {
  default: '',
  sm: 'ui-button-sm',
  lg: 'ui-button-lg',
};

export function Button({
  className,
  variant = 'default',
  size = 'default',
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      className={cn('ui-button', variantClass[variant], sizeClass[size], className)}
      {...props}
    />
  );
}
